import React from 'react';
import {
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  Tooltip,
} from "recharts";

const COLORS = ['#2f5f6e', '#4b57c3', '#183853'];

const ByPlatformCharts = ({ chartData, chartTitle, chartDescrpition }: any) => {
  return (
    <div className=" shadow-sm rounded-xl border border-[#bad5f1]  bg-[#E6F1FC] p-6">
      {/* Header Section */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-[#183853]">{chartTitle}</h2>
        <p className="text-sm text-gray-500">{chartDescrpition}</p>
      </div>

      {/* Chart Section */}
      <div className="flex flex-col items-center">
        <ResponsiveContainer width="100%" height={350}>
          <PieChart  style={{ pointerEvents: "none" }}>
            <Pie
              data={chartData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={({ name, percentage }: any) => `${name}: ${percentage}%`}
              outerRadius={110}
              fill="#8884d8"
              dataKey="value"
            >
              {chartData.map((entry: any, index: number) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>

        {/* Legend Section */}
        <div className="mt-4 space-y-2 w-full">
          {chartData.map((item: any, index: number) => (
            <div
              key={item.name}
              className="flex items-center justify-between text-sm"
            >
              <div className="flex items-center gap-2">
                <div
                  className="w-3 h-3 rounded-full"
                  style={{ backgroundColor: COLORS[index] }}
                />
                <span className="font-medium text-[#183853]">{item.name}</span>
              </div>
              <span className="text-gray-500">
                {item.value.toLocaleString()} ({item.percentage}%)
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ByPlatformCharts;
